<template>
  <div
    class="w-96 h-96 rounded-full bg-[#323232] border border-[#92969e28] absolute -z-20 lg:w-[600px] lg:h-[600px] md:w-[500px] md:h-[500px]"
  >
    <div
      class="w-48 h-48 rounded-full bg-[#303030cc] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center lg:w-80 lg:h-80 md:w-72 md:h-72"
    ></div>
  </div>
</template>

<script>
export default {
  name: "EclipseBackground",
};
</script>

<style></style>
